import { html, when } from '@microsoft/fast-element';
import { avatarTemplate as fastAvatarTemplate } from '@microsoft/fast-foundation';
export const foundationAvatarTemplate = (context, definition) => fastAvatarTemplate(context, definition);
export const media = html `
  ${when((x) => x.imgSrc, html `
      <img src="${(x) => x.imgSrc}" alt="${(x) => x.alt}" slot="media" class="media" part="media" />
    `)}
`;
